import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slide, Box } from "@mui/material";
import { forwardRef } from "react";
import WarningIcon from '@mui/icons-material/Warning';
import { logoutStyles } from "./styles";
import { useTheme } from "@mui/material/styles";

// Slide transition effect
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteModel = ({ openDialog, setOpenDialog, title, functionalCall }) => {
    const theme = useTheme();
    const classes = logoutStyles(theme);

    return (
        <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            slots={{ transition: Transition }}
            keepMounted
            maxWidth="xs"
            fullWidth
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 2,
                        p: 2,
                        boxShadow: 6,
                        width: 500,
                    },
                },
            }}

        >
            {/* Icon on top */}
            <Box sx={classes.rootDiv}>
                <WarningIcon color="error" sx={{ fontSize: 50 }} />
            </Box>

            <DialogTitle sx={classes.title}>
                Delete
            </DialogTitle>

            <DialogContent>
                <DialogContentText sx={classes.subtitle}>
                    {title}
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={classes.btnDiv}>
                <Button
                    variant="outlined"
                    onClick={() => setOpenDialog(false)}
                    sx={{ borderRadius: 2 }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={functionalCall}
                    color="error"
                    variant="contained"
                    sx={{ borderRadius: 2, px: 3 }}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteModel;
